

import ProductCustomizer from '@/components/customizer/Product'

export default {
  name: 'DealPage', // Product page
  components: {
    ProductCustomizer
  }
}
